import React from "react";

export const PerformanceFactors = () => {
  return (
    <div className="performance-factors">

      <div className="performance-factors-item">
        <span className="title">HIGE:</span>
        &nbsp;
        <span className="sign-line" />
      </div>
      <div className="performance-factors-item">
        <span className="title">HOGE:</span>
        &nbsp;
        <span className="sign-line" />
      </div>
      <div className="performance-factors-item">
        <span className="title">INIT:</span>
        &nbsp;
        <span className="sign-line" />
      </div>
    </div>
  )}
